import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class SmsAccountAdminBankModel {
  @Expose()
  public id?: number;

  @Expose()
  public name?: string;

  @Expose()
  public accountNumber?: string;

  @Expose()
  public description?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(SmsAccountAdminBankModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(SmsAccountAdminBankModel, camelcaseKeys(data, { deep: true }) as SmsAccountAdminBankModel[], { excludeExtraneousValues: true });
  }
}
